import React from 'react';
import ReactDOM from 'react-dom/client';
import "./assets/css/custom.css";
import { BrowserRouter } from 'react-router-dom';
import App from './App';



ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter basename="/">
      <App />
    </BrowserRouter>

  </React.StrictMode>
)



